import type { OrganizationUserRole } from '@ent/permissions-shared';
import { DEFAULT_ORGANIZATION_USER_ROLE } from '@ent/permissions-shared';

/** Head-of-kitchen titles that receive manager org role (not line/prep staff). */
export const LEADERSHIP_KITCHEN_POSITIONS = [
  'chef',
  'sous_chef',
  'pastry_chef',
  'kitchen_manager'
] as const;

const LEADERSHIP_SET = new Set<string>(LEADERSHIP_KITCHEN_POSITIONS);

const LEGACY_POSITION_ALIASES: Readonly<Record<string, string>> = {
  lineCook: 'line_cook',
  foodRunner: 'food_runner',
  serverAssistant: 'server_assistant'
};

/** Matches `canonicalPosition` in employee-form-values for known titles. */
export function isLeadershipKitchenPosition(
  value: string | null | undefined
): boolean {
  if (!value) return false;
  const canonical = LEGACY_POSITION_ALIASES[value] ?? value;
  return LEADERSHIP_SET.has(canonical);
}

export function defaultOrganizationRoleForPosition(
  position: string | null | undefined
): OrganizationUserRole {
  return isLeadershipKitchenPosition(position)
    ? 'mgr'
    : DEFAULT_ORGANIZATION_USER_ROLE;
}
